export type HotelNameMatch = { start: number; end: number }

// 全角/半角・大文字/小文字・カタカナ/ひらがなの違いを無視して検索するための正規化
const toSearchable = (text: string): string =>
  text
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[ァ-ヶ]/g, char => String.fromCharCode(char.charCodeAt(0) - 0x60))

// 一致箇所を元の名称上の位置に戻すため、文字単位で正規化する。
// 半角カナの濁点・半濁点は単独で正規化すると結合文字になり「ｶﾞ」が「が」に一致しないため、直前の文字とまとめる。
// U+3099 / U+309A: 結合用濁点・半濁点、U+FF9E / U+FF9F: 半角濁点・半濁点
const SOUND_MARKS = '\\u3099\\u309A\\uFF9E\\uFF9F'
const CHAR_WITH_SOUND_MARKS = new RegExp(`(?:[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]|[\\s\\S])[${SOUND_MARKS}]*`, 'g')
const splitIntoChars = (text: string): string[] => text.match(CHAR_WITH_SOUND_MARKS) ?? []

/**
 * ホテル名にキーワードが部分一致する位置を返す。一致しなければ null。
 * start / end は元のホテル名に対する位置（end は含まない）。
 */
export const findHotelNameMatch = (name: string, keyword: string): HotelNameMatch | null => {
  const normalizedKeyword = toSearchable(keyword.trim())
  if (!normalizedKeyword) return null

  let normalizedName = ''
  const sourceStarts: number[] = []
  const sourceEnds: number[] = []
  let position = 0
  splitIntoChars(name).forEach(char => {
    const normalizedChar = toSearchable(char)
    for (let i = 0; i < normalizedChar.length; i += 1) {
      sourceStarts.push(position)
      sourceEnds.push(position + char.length)
    }
    normalizedName += normalizedChar
    position += char.length
  })

  const matchIndex = normalizedName.indexOf(normalizedKeyword)
  if (matchIndex < 0) return null

  return {
    start: sourceStarts[matchIndex],
    end: sourceEnds[matchIndex + normalizedKeyword.length - 1],
  }
}
